import React from 'react'
import {setHelpContext} from "./HelpManager"
import {prosLogErr} from "./ProsConnect"
import * as prosConnect from "./ProsConnect";
import Checkbox from '../components/Checkbox';
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import TextInput from "../components/TextInput";
import Spacer from "../components/Spacer";
import prosAppNotif from "./ProsAppNotif";

//This is work in progress, system existed previously
export const POPUP_TYPES = {
    fullscreen: 'popup-fullscreen',
    fullwidth: 'popup-fullwidth',
    fullheight: 'popup-fullheight'
}

/*
 * There are two main types of "simplified" popup's with target to reduce boiler plate code:
 *      'dynamic' popup which content is changing directly by changes in caller's state.
 *                  contents is provided by renderCallBack()
 *      'static' or better called 'standalone' popup contents is provided in "html" component.
 *                  html may contain in addition to static contents any independent interactive
 *                  (both react controlled or uncontrolled) elements
 *                  Result to caller is provided by submit or by action button's in 'html' contents.
 *
 * Only UI that uses 'dynamic' shall call prosPopupRender().
 * Such a component should call prosPopupCloseAll() to close its own popups when a component is closed.
 *
 * Popup's could be called also from react hook UI components (not tested) with a few constrains
 *      - "ui" shall be an unique name instead of "this"
 *      - "ui" provided by render and close callbacks as a parameter is not a view context like
 *              for a react class based UI component
 *
 * Example: prosPopupOpen(this, "Title", <h1>Hello World</h1>)
 * Ref examples in code:
 *      - static:  SearchReportSettings.js ~line 714 openPopupDatePicker()
 *      - dynamic: ProjectReports.js ~line 2420 openMakeLinkPopup()
 */


// Popup host is a main UI context that is used to render "static" popup in which contents is not dependent on
// caller UI state but only components inside (html) contents.
// May be removed when have expended App to render popup (or have a separate html element in index.html for popup)
let popupHostUi = undefined
let popupHostName = "?"

// Popup stack contains possible stacked popups that are closed from top, stack parameters
//      ui              context "this" of the caller UI component
//      title           popup title
//      html            popup "static" html from caller - html contents may contain UI components and buttons etc
//      renderCallback  is an alternative for "html" - used for dynamic popup's where popup contents
//                      is rendered and refreshed from changes in caller's state
//      closeCallback   action used to inform caller that popup was closed
//      type            Ref POPUP_TYPES above to show large popup instead of default "match contents"
let popupStack = []


/**
 * UI component that creates a dynamic ( caller's state dependent ) popup shall include render to main page contents
 * @param ui                    Unique caller id
 * @param callerName            Caller name for debugging purposes
 * @returns {JSX.Element|null}  Contents to be rendered showing a modal popup
 */
export function prosPopupRender(ui, callerName) {
    if (popupStack.length < 1) {
        return null
    }
    let popup = popupStack[popupStack.length-1]

    // Dynamic popup is rendered by creator - other popups by popupHost
    let isDynamicPopup = popup.hasOwnProperty('renderCallback')
    let renderer = isDynamicPopup ? popup.ui : popupHostUi
    if (ui !== renderer) {
        return null
    }
    return (
        <div className={"popup-menu " + (popup.type || []).join(" ")}>
            <div className={"popup-container"}>
                <div className={"popup-content"}>
                    <header>
                        <h2>{popup.title}</h2>
                        <BasicButton
                            icon={"times"}
                            action={()=>{
                                prosPopupClose()
                            }}
                        />
                    </header>
                    {popup.html
                        ? popup.html
                        : popup.renderCallback(popup.ui)}
                </div>
            </div>
            <div className={"overlay"}
                 onClick={() => { prosPopupClose() }}/>
        </div>
    )
}

function renderPromptText(ui, title, placeHolder, setText) {
    const DOM_ID_PROMPT_TEXT = "promptText"
    return <>
        <section>
            <TextInput
                id={DOM_ID_PROMPT_TEXT}
                placeholder={placeHolder}
                multiline={3}
                autoFocus
            />
        </section>
        <footer className={"popup-footer"}>
            <div className={"btn-set"}>
                <CancelButton
                    action={()=> prosPopupClose()}
                />
                <ConfirmButton
                    label={title}
                    action={()=> setText(document.getElementById(DOM_ID_PROMPT_TEXT).value)}
                />
            </div>
        </footer>
    </>
}

// Popup with title and html,
// optional close callback is called with 'ui' ( user app context) as call parameter

/**
 * Open a "static" or better called "standalone" popup
 * @param ui        UI component unique id - may use "this" for react class based component
 * @param title     Popup title
 * @param html      Contents (jsx) - may contain standlone interactive components and buttons etc
 * @param closeCallback     Optional callback if need to inform caller - app may also close using prosPopupClose()
 */
export function prosPopupOpen(ui, title, html, closeCallback = undefined) {
    popupStack.push({ui, title, html, closeCallback})
    if (popupHostUi) {
        popupHostUi.setState({ prosPopupStackLength: popupStack.length })
    }
}


export function prosPopupOpenSendFeedback() {
    if (!popupHostUi) {
        prosLogErr('prosPopupOpenSendFeedback(): Popup host is not set')
        return
    }
    let title = 'Lähetä palaute'
    const DOM_ID_FB_TEXT = "feedbackText"
    const DOM_ID_FB_LOGS = "feedbackLogs"
    const DOM_ID_FB_CONTACT = "feedbackContact"

    async function sendFeedback() {
        let feedBackText = document.getElementById(DOM_ID_FB_TEXT).value
        let feedBackLogs = document.getElementById(DOM_ID_FB_LOGS).checked
        let feedBackContact = document.getElementById(DOM_ID_FB_CONTACT).checked
        if (!feedBackText) {
            prosAppNotif('Palaute puuttuu')
            return
        }
        await prosConnect.reportSessionErrorToServer()
        await prosConnect.sendFeedback({
            user_text: feedBackText,
            fb_type: 'v1',
            request_contact: feedBackContact,
            send_logs: feedBackLogs,
        })
        prosPopupClose()
        prosAppNotif( 'Kiitos palautteesta!')
    }

    // TODO Dropdown for feedback type
    let html = <>
        <section>
            <Spacer/>
            <TextInput
                id={DOM_ID_FB_TEXT}
                placeholder={'Anna palaute'}
                autoFocus
                multiline={5}
            />
            <Checkbox
                text="Lupa lähettää virhe- ja tapahtumatiedot"
                defaultChecked={true}
                id={DOM_ID_FB_LOGS}
            />
            <Checkbox
                text="Ota minuun yhteyttä"
                defaultChecked={false}
                id={DOM_ID_FB_CONTACT}
            />
        </section>
        <footer className={"popup-footer"}>
             <div className={"btn-set"}>
                 <ConfirmButton
                     label={"Lähetä palaute..."}
                     confirmAction
                     action={()=> sendFeedback()}
                 />
             </div>
        </footer>
    </>
    popupStack.push({title, html})
    popupHostUi.setState({ prosPopupStackLength: popupStack.length })
}

//   Both render and close callback gets one parameter "ui" which is caller's "this" context
// Note - dynamic popup needs to be rendered by caller that owns the "changing / dynamic" state.

/**
 * Dynamic or better called "caller state dependent" popup with callback to render contents.
 * @param ui                Unique caller's id for class based use "this"
 * @param title             Popup title
 * @param renderCallback    Dynamic - typically caller state dependent jsx contents
 * @param closeCallback     Optional callback when popup is closed
 * @param type              Ref POPUP_TYPES above in this file
 */
export function prosPopupOpenDynamic(ui, title, renderCallback, closeCallback = undefined, type = undefined) {
    popupStack.push({ui, title, renderCallback, closeCallback, type})
    if (popupHostUi) {
        popupHostUi.setState({ prosPopupStackLength: popupStack.length })
    }
}

/**
 * Prompt for a text
 * @param ui                Unique caller's id for class based use "this"
 * @param title             Popup title
 * @param placeHolder       Text shown in text field when it is empty
 * @param setText           callback used to provide with user entered text as a parameter setText(text)
 * @param closeCallback     Optional callback when popup is closed
 */
export function prosPopupOpenPromptText(ui, title, placeHolder, setText, closeCallback = undefined) {
    prosPopupOpenDynamic(ui,
        title,
        () => renderPromptText(ui, title, placeHolder, setText),
        closeCallback
    )
}

/**
 * To close caller UI one topmost popup
 */
export function prosPopupClose() {
    if (popupStack.length < 1) {
        return
    }
    let popup = popupStack.pop()
    if (popup.closeCallback) {
        popup.closeCallback(popup.ui)
    }
    // length is updated to get popup host UI been refreshed
    if (popupHostUi) {
        popupHostUi.setState({ prosPopupStackLength: popupStack.length })
    } else {
        prosLogErr('prosPopupClose(): popup host is undefined')
    }
    // Notify help manager to close potential popup specific help and restore back to a page help
    setHelpContext('closePopup')
}

// Close all stacked popup's
/**
 * To close caller UI all popups
 * @param ui   Unique caller's id for class based use "this"
 */
export function prosPopupCloseAll(ui) {
    if (popupStack.length < 1) {
        return
    }
    let topMostPopup = popupStack[popupStack.length-1]
    // If topmost popup is own - close it
    if (topMostPopup.ui === ui) {
        prosPopupClose()
    }
    // Remove possible other caller's popups from popup stack
    let otherUiPopups = popupStack.filter(popup => popup.ui !== ui)
    popupStack = otherUiPopups
}

/**
 * Set host rendering static / standalone modal popup ( very few needed for example Home )
 * @param ui        Unique caller's id
 * @param name      Caller's name for debugging
 */
export function prosPopupSetHost(ui, name) {
    popupHostUi = ui
    if (ui) {
        prosConnect.prosLog("prosPopupSetHost set:", popupHostName)
    } else {
        prosConnect.prosLog("prosPopupSetHost cleared, popups removed", popupStack.length)
        popupStack.length = 0
    }
    popupHostName = ui ? name : "?"
}

// Deprecated - provided for backwards compatibility - ref replacements from ProsAppNotif
// Convert parameters for new notification
export function prosNotificationShow(ui, txt, type, dismissByUser, showLoadingSpinner, notifButtonSettings) {
    let title = undefined
    let text
    if (Array.isArray(txt)) {
        title = txt[0]
        text = txt[1]
    } else {
        text = txt
    }
    let notifParams = {
        title: title,
        showWait: showLoadingSpinner,
        dismissByUser: dismissByUser,
        type: typeof type === 'string' ? type : (type ? "notice" : "")
    }
    if (notifButtonSettings) {
        notifParams.action = notifButtonSettings.action
        notifParams.icon = notifButtonSettings.icon
        notifParams.buttonText = notifButtonSettings.text
    }
    prosAppNotif(text, notifParams)
}
